import type { FC, PropsWithChildren } from 'react'
import { useState } from 'react'
import styled from '@emotion/styled'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import CoverImage from './CoverImage'

const Video: FC<PropsWithChildren<unknown>> = () => {
  const [playing, setPlaying] = useState(false)
  const play = () => setPlaying(true)
  const stop = () => setPlaying(false)

  return (
    <Wrapper>
      <VideoPlayerBase
        url="https://www.youtube.com/watch?v=nhaKSvfpxIY"
        playing={playing}
        onPause={() => {
          stop()
        }}
        onPlay={() => {
          play()
        }}
      >
        {!playing && <VideoPlayer.BigPlayButton onClick={play} key="play-btn" />}
        {!playing && <CoverImage key="cover" />}
      </VideoPlayerBase>
    </Wrapper>
  )
}

export default Video

const Wrapper = styled.div`
  max-width: 800px;
  padding: 40px 25px 0;
  margin: auto;
  box-shadow: 0px 97px 60px -75px ${({ theme }) => theme.palette.brand.darkAcai[300]};

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 80px;
  }
`
